import { z } from 'zod'
import { oc } from '@orpc/contract'

export const transferAppointment = oc
  .route({ method: 'POST', path: '/v2/appointments/{id}/transfer' })
  .input(
    z.object({
      id: z.string(),
      targetSlot: z.object({}).passthrough(),
      preventFutureBookings: z.boolean().optional(),
    }),
  )
  .output(
    z.object({
      success: z.boolean(),
      newAppointmentId: z.string().nullable(),
      newEncounterId: z.string().nullable(),
      message: z.string().nullable(),
    }),
  )
